export class DoctuUser {
  constructor(attrs) {
    Object.assign(this, this.defaults(), attrs);
  }

  defaults() {
    return {
      id: "",
      account_id: "",
      fio: "",
      email: "",
      login: "",
      phone: "",
      work_phone: "",
      work_phone_ext: "",
      position: "",
      status: "ACTIVE",
      clinicsList: [],
      comment: "",
      passwordHash: '',
      changePassword: false,
      params: {
        report: {
          emailLogin: '',
          emailPassword: '',
          emailSignature: '',
        },
      },
      notifications: [],
      permissions: [],
      roles: [],
    }
  }

  reset() {
    Object.assign(this, this.defaults());
  }
}
